<!-- 弹框 公共模板-->

<template>
<el-dialog title :modal-append-to-body="false" :show-close="false" :top="defaultTop" :close-on-click-modal="false" custom-class="vistable_dialog" :visible.sync="openCardDialog" :width="diaWidth" style="background:rgba(0,0,0,.65)">
  <div class="outside_box">
    <div :class="[types == 'login' && 'login_bg',types == 'signup' && 'signup_bg','box-bg',types == 'phone' && 'phone_bg']">
      <div class="closelogin-box" v-if="types">
        <div :class="[types == 'phone' && 'phone' ,  'close-btn']">
          <div  class="diatitle"><span>{{  types == 'phone' ? '' : $t(diaTitle)}}</span></div>
          <div @click="closeDiaLog" :class="types == 'phone' ? 'closelogin_phone' : 'closelogin'"></div>
        </div>
        <div v-if="types != 'phone'" class="logo-show"><img src="../../assets/images/common/logo.png" alt width="100%" height="auto"/></div>
        <div v-else class="logo-show phone"><img src="./img/phone_logo.png" alt width="100%" height="auto"/></div>
        <div v-if="types == 'phone'" class="tips frist">{{$t('dialogphone.title')}}</div>
        <div v-if="types == 'phone'" class="tips">{{$t('dialogphone.title2')}}</div>
      </div>

      <div v-else :class="['closelogin-box', 'other-box']">
        <div v-if="types == 'signup'"><img src="../../assets/images/common/logo.png" alt /></div>
        <div :style="{ 'color':iscolor}" style="padding-top:15px;">
          <span v-if="deposit == 'marquee'"><img src="./marquee/img/_white.png" alt style="margin-top:-3px;"/></span>
          <span>{{ $t(diaTitle)}}</span>
        </div>
        <div @click="closeDiaLog" class="otherclose"></div>
      </div>

      <div class="dia-content">
        <slot></slot>
      </div>
    </div>
  </div>
</el-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    diaWidth: {
      type: String,
      default: "30%",
    },
    diaTitle:{
        type: String,
        required: false,
    },
    visible:{
        type:Boolean,
        default:false
    },
    types:{
        type:String,
        default:''
    },
    iscolor:{
      type:String,
      default:''
    },
    defaultTop:{
      type:String,
      default:'12vh'
    },
    deposit:{
      type:String,
      default:''
    }
  },
  computed: {
    ...mapState({
        UUID: state => state.UUID,
    }),
    openCardDialog:{
        get(){
            return this.visible
        },
        set(val){
            this.$emit('update:visible',val)
        }
    }
  },
  methods: {
     closeDiaLog(){
        if(this.types) return this.$emit('handleCloseDialog')
        if(this.deposit == 'deposit') return this.$emit('handeLeClose')
        this.openCardDialog = !this.openCardDialog
     },
  },
};
</script>

<style scoped lang="scss">
$border:6px;
@mixin common_1($val:20px){
  color: #fff;
  font-size: $val;
  font-weight: 800;
  font-family: Roboto-Black;
}
@mixin common_2{
  width: 24px;
  height: 25px;
  background-image: url('../../assets/images/common/close.png');
  background-size: contain;
  cursor: pointer;
  transition: all 200ms;
  &:hover{ transform: rotate(90deg); }
}

@mixin common_3{
  display:flex;
  justify-content: space-between;
}
@mixin _bg{ 
 background-repeat: no-repeat;
    background-size: cover;
}
.vistable_dialog {
  .diatitle {
    width: 100%;
    position: relative;
    @include common_1;
  }
  
  .box-bg {
    height: 100%;
    position: relative;
    margin:0 auto;
    width:100%;
    background-color:#f0f0f0;
    border-radius: 6px;
    &.signup_bg{  background-image:url('./img/signup_bg.png');@include _bg;border-radius: 15px;}
    &.login_bg{ background-image:url('./img/login_bg.png'); @include _bg;border-radius: 16px;}
    &.phone_bg{background-image:url('./img/phone_bg.png'); @include _bg;border-radius: 15px;}
    .closelogin-box {    // 登录
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      .close-btn{
        @include common_3;
        padding:25px 23px 0;
        &.phone{
          padding:15px 15px 0
        }
        .closelogin {
          @include common_2;
        }
        .closelogin_phone {
          width: 44px;
          height: 38px;
          background-image: url('./img/Group.png');
          background-size: contain;
          cursor: pointer;
          display:none;
        }
      }
      .logo-show{     // 登录
        margin:10px auto 22px;
        width:117px;
        &.phone{
          width:150px;
        }
      }
      .tips{
        text-align: center;
        color: #fff;
        font-size:18px;
        &.frist{
          font-size:22px;
          font-weight:600
        }
      }
    }
    .other-box{  // 其他
      @include common_1(20px);
      // text-align: center;
      background-image: linear-gradient(90deg,#10aef7 0%,#a3eb90 100%);
      // padding:6px 20px 13px;
      height:60px;
      padding-left:26px;
      .otherclose{
        position: absolute;
        z-index:1;
        right:19px;
        top:20px;
        @include common_2;
      }
    }
    .dia-content{
      padding:10px 20px 0;
      // background:#fff;
      border-bottom-left-radius:$border;
      border-bottom-right-radius:$border;
    }
  }
}
</style>

<style lang="scss">
.vistable_dialog{
  &.el-dialog{ background:transparent!important; }
   .el-dialog__header,.el-dialog__body{ padding:0!important;}
}
</style>


// WEBPACK FOOTER //
// src/pages/build901/components/common/dialogTem.vue